import { render, staticRenderFns } from "./SsoSignInCallback.vue?vue&type=template&id=9447af3e&"
import script from "./SsoSignInCallback.vue?vue&type=script&lang=js&"
export * from "./SsoSignInCallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports